AddSectionCommentButton = require 'components/document_sections/v2/add_section_comment_button'
{ getRecommendationDirectionAndStrength, getCertaintyOfEvidenceCircles } = require 'lib/services/covid_exporter/utils'
{ RECOMMENDATION_SECTION_APPENDICES_ORDER } = require 'lib/document_sections_v2_helper'
MagicWhoRecommendationType = require 'components/document_sections/v2/magic_who_recommendation_type'
{ useCoffeeMemo, useI18n } = require 'lib/react_utils'
DocumentSectionsTitle = require 'components/document_sections/v2/document_sections_title'
DocumentSectionsV2Actions = require 'actions/document_sections_v2_actions'
{ WHO_WORKSPACES } = require 'lib/who_helper'
mediator = require 'mediator'
EtdEditor = require 'components/etd/etd_editor'

CertaintyOfEvidence = ({ question, recommendation }) ->
  { label, signs } = useCoffeeMemo [question, recommendation], ->
    { label, circles } = getCertaintyOfEvidenceCircles question, recommendation
    circles = _.map circles, (sign, idx) ->
      <span className="quality-sign" key={idx} dangerouslySetInnerHTML={{ __html: sign }} />
    { label, signs: circles }

  <div className="certainty-of-evidence">
    <div>{signs}</div>
    {label and <div>{label}</div>}
  </div>

CertaintyOfEvidence.propTypes =
  question: PropTypes.instanceOf(Immutable.Map).isRequired
  recommendation: PropTypes.instanceOf(Immutable.Map).isRequired

RecommendationSectionContent = ({ question, editable, onAddComment, recommendation, section, selectedAppendices }) ->
  i18n = useI18n('es:recommendations.metadataExtractionForm.fields')

  handleTitleSave = (changedTitle) -> updateField('title', changedTitle)

  updateField = (key, value) ->
    projectId = mediator.project.id
    chapterId = section.get('parent')
    sectionId = section.get('_id')
    DocumentSectionsV2Actions.setSectionProperty(
      projectId, chapterId, sectionId, key, value
    )

  recommendationText = recommendation.getIn(
    ['templateData', 'conclusions', 'sections', 'recommendation', 'content']
  )

  remarks = recommendation.getIn(
    ['templateData', 'conclusions', 'sections', 'recommendation', 'remarks'], Immutable.Map()
  )

  [ _recommendationDirection, recommendationStrength ] =
    getRecommendationDirectionAndStrength recommendation.toJS()

  isAnyAppendixChecked = useCoffeeMemo [selectedAppendices], ->
    selectedAppendices.some _.identity

  <div className="recommendation">
    {onAddComment and <AddSectionCommentButton onClick={onAddComment} />}
    {mediator.activeWorkspace in WHO_WORKSPACES and <DocumentSectionsTitle
      onSave={handleTitleSave}
      sectionType={section.get('sectionType')}
      editable={editable}
      title={section.get('title')}
    />}
    <MagicWhoRecommendationType recommendation={recommendation} />
    <div className="recommendation-text">
      <EtdEditor
        content={recommendationText}
        editable={false}
      />
    </div>
    {!remarks.isEmpty() && <div className="recommendation-remarks">
      <p className="recommendation-remarks__title">
        {i18n '/docsec:recommendation_section.remarks'}
      </p>
      <div className="recommendation-remarks__content">
        <EtdEditor
          content={remarks.get('content', '')}
          editable={false}
        />
      </div>
    </div>}
    {mediator.activeWorkspace not in WHO_WORKSPACES and <div className="recommendation-attributes">
      {question and not question.isEmpty() and <div>
        <div>{i18n 'certaintyOfEvidence'}</div>
        <CertaintyOfEvidence question={question} recommendation={recommendation} />
      </div>
      }
      {recommendationStrength and <div>
        <div>{i18n 'strengthOfRecommendation'}</div>
          <div>
              {i18n "/docsec:recommendation_strength.#{recommendationStrength}"}
          </div>
        </div>
      }
    </div>}
    {isAnyAppendixChecked and <div className="recommendation-appendices">
      <p className="recommendation-appendices__title">
        {i18n '/docsec:management.section_appendices.title'}
      </p>
      {_.chain RECOMMENDATION_SECTION_APPENDICES_ORDER
        .map (key) ->
          return null unless selectedAppendices.get key
          <p className="mt-10" key={key}>
            {i18n "/docsec:management.section_appendices.#{key}"}
          </p>
        .compact()
        .value()
      }
    </div>}
  </div>

RecommendationSectionContent.propTypes =
  question: PropTypes.instanceOf(Immutable.Map).isRequired
  recommendation: PropTypes.instanceOf(Immutable.Map).isRequired
  selectedAppendices: PropTypes.instanceOf(Immutable.Map)
  onAddComment: PropTypes.func
  editable: PropTypes.bool.isRequired
  section: PropTypes.instanceOf(Immutable.Map).isRequired

RecommendationSectionContent.defaultProps =
  selectedAppendices: Immutable.Map()

module.exports = RecommendationSectionContent
